import { render, staticRenderFns } from "./login_footer.vue?vue&type=template&id=1a515b96&scoped=true&"
import script from "./login_footer.vue?vue&type=script&lang=js&"
export * from "./login_footer.vue?vue&type=script&lang=js&"
import style0 from "./login_footer.vue?vue&type=style&index=0&id=1a515b96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a515b96",
  null
  
)

export default component.exports